class PayOutAccountRequest {
  static create = {
    payOutAccountCustomerId: null,
    payOutAccountNumber: null,
    payOutAccountBank: null,
    payOutAccountStatus: null
  };

  static update = {
    payOutAccountCustomerId: null,
    payOutAccountNumber: null,
    payOutAccountBank: null,
    payOutAccountStatus: null,
    payOutAccountName: null,
    payOutAccountCountry: null,
    otp: null
  };

  static readBy = {
    payOutAccountId: null
  };

  static getCountries = {};

  static createStripePayoutAccount = {
    countryCode: null
  };
}

export default PayOutAccountRequest;
